export default __webpack_public_path__ + "static/media/icon-caretDownBlack.f7c6733e.svg";